import { useEffect } from 'react';
import { doc, setDoc, deleteDoc } from 'firebase/firestore';
import { db as firestore } from '../firebase/firebaseConfig';
import { getMeta, setMeta } from '../lib/db';

export function useShare(user, dispatch) {
  // Load existing share tokens from IDB on mount
  useEffect(() => {
    getMeta('shareTokens').then(shareTokens => {
      if (shareTokens) dispatch({ type: 'SET_SHARE_TOKENS', shareTokens });
    });
  }, [dispatch]);

  // Clear tokens from state when user signs out
  useEffect(() => {
    if (!user) dispatch({ type: 'SET_SHARE_TOKENS', shareTokens: {} });
  }, [user, dispatch]);
}

async function persistTokens(dispatch, updater) {
  const current = (await getMeta('shareTokens')) ?? {};
  const next = updater(current);
  await setMeta('shareTokens', next);
  return next;
}

export async function enableSharing(userId, huntId, dispatch) {
  const token = crypto.randomUUID();
  await setDoc(doc(firestore, 'shares', token), {
    userId,
    huntId,
    createdAt: new Date().toISOString(),
  });
  await persistTokens(dispatch, (tokens) => ({ ...tokens, [huntId]: token }));
  dispatch({ type: 'SET_SHARE_TOKEN', huntId, token });
  return token;
}

export async function disableSharing(token, huntId, dispatch) {
  await deleteDoc(doc(firestore, 'shares', token));
  await persistTokens(dispatch, (tokens) => {
    const next = { ...tokens };
    delete next[huntId];
    return next;
  });
  dispatch({ type: 'SET_SHARE_TOKEN', huntId, token: null });
}
